import React, { Component } from "react";

export class test extends Component {
	constructor(props) {
		super(props);
		this.state = {
			content: "",
			focus: false,
            options:[
                {
                    label:"Some Action",
                    value:"mycondition",
                    desc:"Some Action Description"
                }
            ]
		};
	}

    appendContent(option) {
        let value = option.value;
        this.setState((state)=>({
            content:state.content+" "+value
        }));
    }

	render() {
        let { focus, options } = this.state;
		return (
			<AppWrapper>
				<div className="textarea bg-white border border-2 flex">
					<div>{this.state.content}</div>
					<div className="relative">
                        <AppInput
                            type="text"
                            name="search"
                            controlClass={"border border-0"}
                            onFocus={() => this.setState({ focus: true })}>
                        </AppInput>
                        <div className={Object.className({
                            "dropdown absolute top-full bg-white py-2 px-4 border border-2 rounded-md left-0 w-52":true,
                            "hidden":!focus
                        })}>
                            <ul>
                                {options.map((option)=>(
                                    <li data-value={option.value} className="flex cursor-pointer" onClick={()=>this.appendContent(option)}>
                                        <div>
                                            <img src=""></img>
                                        </div>
                                        <div className="grow" >
                                            <div>{option.label}</div>
                                            <div className="mt-1 text-sm text-gray-500">{option.desc}</div>
                                        </div>
                                    </li>
                                ))}
                                
                            </ul>
                        </div>
                    </div>
				</div>
			</AppWrapper>
		);
	}
}

export default test;
